// frontend/src/pages/NotFound.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../config";
import Button from "../components/common/Button";
import { ArrowRightIcon } from "../components/common/Icon";
import "./NotFound.css";

export default function NotFound() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = "Page not found · PAWNI";
  }, []);

  return (
    <section className="not-found container" aria-labelledby="nf-title">
      <p className="eyebrow">Error 404</p>
      <h1 id="nf-title" className="not-found__title">
        That wasn&apos;t <em>the question</em> we expected.
      </h1>
      <p className="not-found__desc">
        There is nothing at <code>{pathname}</code>. The link may be old, or the page may have moved.
      </p>
      <div className="not-found__actions">
        <Button variant="primary" to={ROUTES.home} iconRight={<ArrowRightIcon size={16} />}>
          Back to home
        </Button>
        <Button variant="ghost" to={ROUTES.app}>
          Open the app
        </Button>
      </div>
    </section>
  );
}
